// Scostamento band classifier. Thresholds are stored in the admin settings
// as PERCENTAGES (e.g. -30 for -30%). Callers should divide by 100 before
// passing them here (or use `thresholdsFromSettings`).
export const DEFAULT_SCOST_THRESHOLDS = {
  red: -0.30,
  yellow: -0.20,
  green: -0.10,
  cyan: 0.0,
};

// Convert admin-settings values (percent scale, e.g. -30) into the fraction
// scale used at the row level (e.g. -0.30).
export const thresholdsFromSettings = (settings) => {
  if (!settings) return DEFAULT_SCOST_THRESHOLDS;
  const num = (v, fb) => (Number.isFinite(Number(v)) ? Number(v) / 100 : fb);
  return {
    red:    num(settings.scost_band_red,    DEFAULT_SCOST_THRESHOLDS.red),
    yellow: num(settings.scost_band_yellow, DEFAULT_SCOST_THRESHOLDS.yellow),
    green:  num(settings.scost_band_green,  DEFAULT_SCOST_THRESHOLDS.green),
    cyan:   num(settings.scost_band_cyan,   DEFAULT_SCOST_THRESHOLDS.cyan),
  };
};

// Factory returning a `scostBand(v)` bound to the given thresholds. Kept as
// a factory (not a plain function taking thresholds each call) so the closure
// keeps the per-render allocation to a minimum inside big tables.
export const makeScostBand = (t = DEFAULT_SCOST_THRESHOLDS) => (v) => {
  if (v === null || v === undefined) return { row: "", color: "#8E8E93", label: "n/d" };
  if (v <= t.red)    return { row: "row-scost-red",    color: "#FF3B30", label: `≤ ${Math.round(t.red * 100)}%` };
  if (v <= t.yellow) return { row: "row-scost-yellow", color: "#B27F00", label: `${Math.round(t.yellow * 100)}%` };
  if (v <= t.green)  return { row: "row-scost-green",  color: "#1F7A3A", label: `${Math.round(t.green * 100)}%` };
  if (v <= -0.001)   return { row: "row-scost-cyan",   color: "#00A6B7", label: "-0.1/-9.9%" };
  return { row: "", color: "#0A84FF", label: "≥ 0" };
};

// Default export — used when settings aren't available (e.g. very first
// paint before /admin/settings resolves).
export const scostBand = makeScostBand(DEFAULT_SCOST_THRESHOLDS);
